import React from 'react';
import { useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';

import ruMessages from './messages/ru.json';

const allMessages: { [key: string]: any } = {
  ru: ruMessages,
};

export default function I18nProvider({ children }: { children: React.ReactNode }) {
  const locale = useSelector(({ i18n }: any) => i18n.lang);
  const messages = allMessages['ru'];

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
}
